(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}
		hide() {
			super.hide();
			window.pauseAllMedia();
		}
		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall()
		}
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			let activeMediaIndex = 0
			
			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
					if(element == activeMedia){
						activeMediaIndex = index
					}
				}
			)
			const prodPageSwiper = new Swiper("#featured-product-swiper", {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: ".swiper-button-next-prod-page",
					prevEl: ".swiper-button-prev-prod-page",
				}
			});
			prodPageSwiper.on('init', function() {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init()
			document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
  	constructor() {
  		super();
  		this.elements = {
  			input: this.querySelector(
  				'input[name="locale_code"], input[name="country_code"]'
  			),
  			button: this.querySelector('button'),
  			panel: this.querySelector('ul'),
  		};
  		this.elements.button.addEventListener(
  			'click',
  			this.openSelector.bind(this)
  		);
  		this.elements.button.addEventListener(
  			'focusout',
  			this.closeSelector.bind(this)
  		);
  		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

  		this.querySelectorAll('a').forEach((item) =>
  			item.addEventListener('click', this.onItemClick.bind(this))
  		);
  	}

  	hidePanel() {
  		this.elements.button.setAttribute('aria-expanded', 'false');
  		this.elements.panel.setAttribute('hidden', true);
  	}

  	onContainerKeyUp(event) {
  		if (event.code.toUpperCase() !== 'ESCAPE') return;

  		this.hidePanel();
  		this.elements.button.focus();
  	}

  	onItemClick(event) {
  		event.preventDefault();
  		this.elements.input.value = event.currentTarget.dataset.value;
  		this.querySelector('form')?.submit();
  	}

  	openSelector() {
  		this.elements.button.focus();
  		this.elements.panel.toggleAttribute('hidden');
  		this.elements.button.setAttribute(
  			'aria-expanded',
  			(
  				this.elements.button.getAttribute('aria-expanded') === 'false'
  			).toString()
  		);
  	}

  	closeSelector(event) {
  		const shouldClose =
  			event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  		if (event.relatedTarget === null || shouldClose) {
  			this.hidePanel();
  		}
  	}
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		} 
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


class ProductModal extends ModalDialog {
			constructor() {
				super();
			}
			hide() {
				super.hide();
				window.pauseAllMedia();
			}
			show(opener) {
				super.show(opener);
				//this.showActiveMedia();
				this.constProductPageSwiperCall()
			}
			showActiveMedia() {
				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
				if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
					activeMedia.loadContent();
			}
			
			constProductPageSwiperCall(showActiveMedia) {
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				let activeMediaIndex = 0
				
				this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
						if(element == activeMedia){
							activeMediaIndex = index
						}
					}
				)
				const prodPageSwiper = new Swiper("#product-page-swiper", {
					zoom: true,
					centeredSlides: false,
					slidesPerView: 1,
					autoheight: true,
					watchSlidesVisibility: false,
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
					init: false,
					navigation: {
						nextEl: ".swiper-button-next-prod-page",
						prevEl: ".swiper-button-prev-prod-page",
					},
					pagination: {
						el: ".swiper-pagination-product-page",
						clickable: true,
					},
					//on: {
					//	click: function (e) {
					//			if (this.zoom.scale === 1) {
					//			this.zoom.in();
					//			} else {
					//				this.zoom.out();
					//			}
       		//	 },
					//},
				});
				prodPageSwiper.on('init', function() {
					prodPageSwiper.slideTo(activeMediaIndex, 0, false);
				});
				prodPageSwiper.init()
				document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
			}
		}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            
            // Initialize Splide after recommendations are inserted
            // Use setTimeout to ensure DOM is fully updated
            setTimeout(() => {
              this.initializeSlider();
            }, 100);
          }
        })
        .catch((e) => {
          console.error('Error fetching recommendations:', e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);
  }

  initializeSlider() {
    // Find the slider within this component instance
    const slider = this.querySelector('.splide.recommendation__product--slider');
    
    if (slider && typeof Splide !== 'undefined') {
      try {
        new Splide(slider, {
          type: "slide",
          perPage: 4,
          perMove: 1,
          classes: {
            arrows: 'splide__arrows featured__collection--arrows'
          },
          gap: "5px",
          padding: "0",
          arrows: true,
          drag: true,
          pagination: false,
          breakpoints: {
            768: {
              perPage: 2,
              arrows: false,
              padding: { left: '0rem', right: '8rem' },
            }
          },
        }).mount();
      } catch (error) {
        console.error('Error initializing Splide slider:', error);
      }
    } else {
      console.warn('Splide slider element not found or Splide library not loaded');
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function() {
		function appHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
	}
	
		//window.addEventListener('resize', appHeight);
		appHeight();
	});

  } catch(e) { console.error(e); }
})();
})();
